<script>
import Layout from '@layouts/primary'
import Loading from '@/src/components/loading.vue'
import { wastetypeMethods, clientMethods, serviceMethods, serviceAgreementMethods, serviceTypeMethods, siteMethods, binMethods, vehicleMethods } from '@state/helpers'
import { RRule, rrulestr } from 'rrule'
import * as moment from 'moment'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { BASE_URL } from '../../endpoints'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'ViewClient',
    meta: [{ name: 'description', content: 'ViewClient' }],
  },
  components: { Layout, Loading, VueDropzone: vue2Dropzone },
  data() {
    return {
      loadingData: true,
      serviceSearchInput:'',
      wasteSearchInput:'',
      binsSearchInput:'',
      vehicleSearchInput:'',
      dateParsed: '',
      password: '',
      passwordconfirm:'',
      authError: null,
      matchError:null,
      isSafeToDelete: false,
      currentMessage: '',
      showCollection: false,
      showService: false,
      addAgreement: false,
      changePwd: false,
      showNewPassword: false,
      showConfirmPassword: false,
      client: {},
      service: {},
      services: [],
      serviceAgreements: [],
      serviceAgreementID: null,
      serviceTypes:[],
      vehicles:[],
      vehiclePlates:[],
      serviceTypeNames: [],
      serviceTypeName: null,
      serviceTypeByName:[],
      wasteTypes: [],
      wasteType: null,
      wasteTypeName: null,
      wasteTypeNames:[],
      serviceSchedule: {
        freq: null,
        interval: 1,
        byweekday:[],
        bymonth: [],
        until: ''
      },
      newService: {
        service_title: null,
        service_type_id: null,
        client_id: null,
        site_id: null,
        description: null,
        is_recurring: true,
        schedule_string: "RRULE:FREQ=DAILY;WKST=MO",
        // schedule_string: "RRULE:FREQ=DAILY;COUNT=30;WKST=MO",
        // order_number: null,
        time_windows:[[100,2400]],
        service_agreement_id: null,
        serviceOnCall: false, // false as default
      },
      newServiceAgreement: {
        gate_access_method: '12:00',
        gateAccessMethod: '12:00',
        clientId: null,
        siteId: null,
        notes: null,
        agreementCommencementDate: null,
        deliveryDate: null,
        firstPickup: null,
      },
      clientSites:[],
      allTheBins: [],
      binType: null,
      binDescriptions:[],
      currentAgreement:{},
      newServiceBin: {
        binId: null,
        serviceId: null,
        price: 0, // Zero as default
        binIdentifier:null,
        defaultPricing: true,
        issueDate: null,
        weeklyMaintenanceFee: 0, // Zero as default
        chargePerTonne: false,
        chargePerLitre: false,
        weightAllowed: 0,
        extraPrice: 0,
      },
      removeClient:false,
      removeAgreement:false,
      editClient:false,
      editAgreement: false,
      manageDocuments: false,
      fileCount: null,
      shouldReload: false,
      addLocation:false,
      newSite: {
        address: null,
        suburb: null,
        state: null,
        country: null,
        postcode: null,
        clientId: null,
        phone: null,
        mobile: null,
        contactName: null,
        email: null,
        tradingName: null,
      },
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
      serviceHeaders: [
        { text: 'Title', align: 'left', sortable: false, value: 'service_title' },
        { text: 'Description', align: 'left', sortable: false, value: 'service_description' },
        { text: 'Type', align: 'left', sortable: false, value: 'service_type' },
        { text: 'Freq', align: 'left', sortable: false, value: 'frequency' },
        { text: 'Container Fee', align: 'left', sortable: false, value: 'maintenance_fee' },
        { text: 'Service Fee', align: 'left', sortable: false, value: 'service_fee' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      collectionHeaders: [
        { text: 'Service', align: 'left', sortable: false, value: 'service_title' },
        { text: 'Type', align: 'left', sortable: false, value: 'service_description' },
        { text: 'Size', align: 'left', sortable: false, value: 'service_type' },
        { text: 'Schedule', align: 'left', sortable: false, value: 'schedule' },
        { text: 'Container Fee', align: 'left', sortable: false, value: 'maintenance_fee' },
        { text: 'Service Fee', align: 'left', sortable: false, value: 'service_fee' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      locationHeaders: [
        { text: 'Site Name', align: 'left', sortable: false, value: 'Trading Name' },
        { text: 'Street', align: 'left', sortable: false, value: 'Address' },
        { text: 'Phone', align: 'left', sortable: false, value: 'phone' },
        { text: 'Email', align: 'left', sortable: false, value: 'email' },
        { text: 'Contact Name', align: 'left', sortable: false, value: 'Contact Name' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      dropOptions: {
        url: `${BASE_URL}/file/upload`,
        headers: {
          'id': null
        }
      },
      manageDocumentsHeaders:[
        {text:"Document",value: "headers"},
        {text:"Delete",value: "headers", sortable: false},
      ],
      documents: [

      ],
      documentsObj: [

      ],
      removeDocument: false,
      selectedDocumentId: null,
    }
  },
  async mounted() {
    let that = this
    let cid = this.$router.history.current.params.id;
    // this.$validator.localize('en', this.dictionary)
    this.$validator.localize('en', this.dictionary)
    // this.$validatorAgreement.localize('en', this.dictionary)
    await this.getClientById({id: cid}).then(response => {
      that.client = this.$store.state.clients.currentClient;
      that.client.value = true

      // In order to dont mutate state obj, create a "copy of it"
      let formattedObj = {
        ...that.client
      }

      that.client = formattedObj
      this.loadingData = false
    })
    this.getServiceByClientId({id: cid}).then(response => {
      let obj = this.$store.state.services.objects
      for (var v in obj) {
        let formattedObj = {
          ...obj[v]
        }
        formattedObj.id=parseInt(formattedObj.id)
        this.services.push(formattedObj)
      }
    })
    this.getServiceTypes().then(response => {
      let obj = this.$store.state.serviceTypes.objects
      for (var v in obj) {
        let formattedObj = {
          ...obj[v]
        }
        if(formattedObj.active) {
          this.serviceTypeNames.push(formattedObj.id + ' - ' + formattedObj.name)
          this.serviceTypes.push(formattedObj)
        }
      }
    })
    this.getWasteTypes().then(response => {
      let obj = this.$store.state.wastetypes.objects
      for (var v in obj) {
        let formattedObj = {
          ...obj[v]
        }
        this.wasteTypeNames.push(formattedObj.id + ' - ' + formattedObj.name)
        this.wasteTypes.push(formattedObj)
      }
    })
    this.serviceAgreementsByClientId({id: parseInt(cid)}).then(response => {
      let agree = this.$store.state.serviceAgreements.objects
      for (var v in agree) {
        let formattedObj = {
          ...agree[v]
        }
        // store each agreement id as an int
        formattedObj.id=parseInt(formattedObj.id)
        // get the location details for each agreement
        this.serviceAgreements.push(formattedObj)
        // console.log(this.serviceAgreements)

        // get the total maintenance and service fees from each service bin in each service
        let services = formattedObj.services
        for (var i in services){
          // display schedule based on RRule
          if(services[i].schedule_string !== 'ON CALL'){
            // Remove COUNT=5 from the string - REMOVED IT AS IT WASN'T DOING THE CONVERSION RIGHT
            // let schedule = services[i].schedule_string.split(';');
            // let rule = RRule.fromString(schedule[0]);
            let schedule = ''
            let rule = RRule.fromString(services[i].schedule_string);
            schedule= rule.toText();

            services[i].schedule=schedule
          } else {
            services[i].schedule = 'On Call';
          }

          var maintenanceSum = 0
          var serviceSum = 0
          var capacitySum = 0
          var bins = services[i].service_bins
          for (var b in bins){
            if(bins[b].weekly_maintenance_fee) {
              maintenanceSum = maintenanceSum + bins[b].weekly_maintenance_fee
            }
            // check if there is a custom price for the service bin
            // if not - use the default bin price
            if (bins[b].price){
              serviceSum = serviceSum + bins[b].price
            }
            else {
              serviceSum = serviceSum + bins[b].bin.price
            }
            capacitySum = capacitySum + bins[b].bin.capacity
          }
          services[i].serviceSum=serviceSum
          services[i].maintenanceSum=maintenanceSum
          services[i].capacitySum=capacitySum
        }
      }
    })
    this.getBins().then(response => {
      let bin = this.$store.state.bins.objects
      for (var bi in bin) {
        this.binDescriptions.push(bin[bi].description)
        this.allTheBins.push(bin[bi])
      }
    })
    this.sitesByClientId({clientId: parseInt(cid)}).then(s => {
      let site = this.$store.state.sites.objects
      for (let si in site){
        this.clientSites.push(site[si])
      }
    })
    this.getVehicles().then(response => {
      let obj = this.$store.state.vehicles.objects
      for (let v in obj) {
        this.vehiclePlates.push(obj[v].number_plate)
        this.vehicles.push(obj[v])
      }
    })
  },
  methods: {
    ...vehicleMethods,...wastetypeMethods, ...clientMethods, ...serviceMethods, ...serviceAgreementMethods, ...siteMethods, ...serviceTypeMethods, ...binMethods,
    rulify(s) {
      return rrulestr(s).toText().toUpperCase();
    },
    findVehicleByPlate(plate){
      return this.vehicles.find(obj => obj.number_plate === plate)
    },
    async validateForm (scope) {
      // console.log(scope)
      await this.$validator.validateAll(scope).then(result => {
        // console.log(result);
        return result
      });
    },
    async update() {
      await this.$validator.validateAll('form-client-update').then((response) =>{
        if(response) {
          this.client.id = parseInt(this.client.id)
          this.client.postcode = parseInt(this.client.postcode)
          this.updateClient(this.client).then((res) => {
            this.editClient = !this.editClient
          })

        }
      })
    },
    submit() {
      let clientId = parseInt(this.client.id)

      this.deleteClient({id: clientId}).then( d => {
        let route = '/admin/client-center/'
        // location.reload()
        this.changeRoute(route)
      })
    },
    async addService() {
      await this.$validator.validateAll('form-service').then(result => {
        if(result){
          // Add expiry date to a service,
          // Otherwise scheduler will keep adding the collection to runsheet
          this.serviceSchedule.until = this.newService.lastDayService;

          let schedule = new RRule(this.serviceSchedule)

          if(schedule || this.newService.serviceOnCall){
            this.newService.schedule_string = schedule.toString()
            /* get clientsByName was inconsistantly returning different shit
                   created seperate array of service type name and full service type objects
                   use index of selected typename in form to find corresponding id
                 */
            if(this.serviceTypeName)
              var typeName = this.serviceTypeName.toString()

            // console.log(this.newService.serviceOnCall)
            // If admin define that the service is based up On Call
            if(this.newService.serviceOnCall){
              this.newService.schedule_string = 'ON CALL';
            }

            // Get vehicle id if user added it
            if(this.newService.vehicle_id)
              this.newService.vehicle_id = this.findVehicleByPlate(this.newService.vehicle_id).id;

            var serviceIndex = this.serviceTypeNames.indexOf(typeName)
            this.newService.service_type_id = parseInt(this.serviceTypes[serviceIndex].id)

            if (!this.newService.service_title) {
              this.newService.service_title = this.serviceTypes[serviceIndex].name
            }


            let wasteTypeName = this.wasteTypeName.toString()
            let wasteIndex = this.wasteTypeNames.indexOf(wasteTypeName)
            this.newService.waste_type_id = parseInt(this.wasteTypes[wasteIndex].id)

            // parse all the ints
            this.newService.client_id = parseInt(this.client.id)
            this.newService.site_id = parseInt(this.newService.site_id)
            this.createService(this.newService).then( d => {
              let newServiceId = d.data.createService.id
              this.addBin(newServiceId)
            })
          }
        }
      });
    },
    async resetPassword() {
      // Reset the authError if it existed.
      this.authError = null;
      this.matchError = null;
      if(this.password.length < 1){
        this.matchError = true;
        return
      }
      if(this.password !== this.passwordconfirm){
        this.authError = true
      }else{
        // let user = store.getters['auth/getCurrentUser'];
        let id = parseInt(this.client.id)
        await this.updateClientPassword({
          id: id,
          password: this.password,
        })
          .then(response => {
            // this.submitted = true;
            location.reload()
          })
          .catch(error => {
            // console.log(error)
            // this.tryingToLogIn = false
            this.authError = error
          })
      }

    },
    closePwdModal(){
      this.changePwd = !this.changePwd;
    },
    closeManageDocumentModal(){
      this.manageDocuments = !this.manageDocuments;
      if(this.shouldReload)
        location.reload()
    },
    addBin(newServiceId) {
      let moment = require('moment');
      let today = moment.utc().toISOString()
      let binName = this.binType
      let bindex = this.binDescriptions.indexOf(binName)

      this.newServiceBin.issueDate = today
      this.newServiceBin.binId = parseInt(this.allTheBins[bindex].id)
      this.newServiceBin.serviceId = parseInt(newServiceId)
      if(this.newServiceBin.price){
        this.newServiceBin.price = parseInt(this.newServiceBin.price * 100)
        this.newServiceBin.defaultPricing = false
      }
      if(this.newServiceBin.weeklyMaintenanceFee){
        this.newServiceBin.weeklyMaintenanceFee = parseInt(this.newServiceBin.weeklyMaintenanceFee * 100)
      }

      if(this.newServiceBin.weightAllowed) {
        this.newServiceBin.weightAllowed = parseFloat(this.newServiceBin.weightAllowed)
      }

      if(this.newServiceBin.extraPrice){
        this.newServiceBin.extraPrice = parseInt(this.newServiceBin.extraPrice * 100)
      }

      this.addBinToService(this.newServiceBin).then(d => {
        location.reload()
      })
    },
    siteNames(){
      let sites = []
      for(var na in this.clientSites){
        sites.push( {address: this.clientSites[na].address, site_id: this.clientSites[na].id})
      }
      return(sites)
    },
    async saveAgreement(){
      await this.$validator.validateAll('form-agreement').then(result => {
        if(result){
          this.newServiceAgreement.clientId = parseInt(this.$router.history.current.params.id)
          this.newServiceAgreement.siteId = parseInt(this.newServiceAgreement.siteId)

          // Date gate access time needs to be in the format below
          // YYYY-MM-DDTHH:MM:SS+11:00
          let dateParsed = '2001-01-01T';
          dateParsed = dateParsed.concat(this.newServiceAgreement.gateAccessMethod)
          dateParsed = dateParsed.concat(':00+11:00')

          this.newServiceAgreement.gateAccessMethod = dateParsed
          this.createServiceAgreement(this.newServiceAgreement).then(d => {
            location.reload()
          })
        }
      });
    },
    performDeleteAgreement(){
      // console.log('PERFOR')
      this.deleteServiceAgreement({id: parseInt(this.currentAgreement.id)}).then(() => {
        this.shouldReload = true
        location.reload()
      })
    },
    async updateAgreement(){
      // console.log('this.currentAgreement', this.currentAgreement)
      // Date gate access time needs to be in the format below
      // YYYY-MM-DDTHH:MM:SS+11:00
      let dateParsed = '2001-01-01T';
      dateParsed = dateParsed.concat(this.currentAgreement.gate_access_method)
      dateParsed = dateParsed.concat(':00+11:00')
      this.updateServiceAgreement({
        id: this.currentAgreement.id,
        siteId: parseInt(this.currentAgreement.site_id),
        gateAccessMethod: dateParsed,
        notes: this.currentAgreement.notes,
        agreementCommencementDate: this.currentAgreement.agreement_commencement_date,
        agreementEndDate: this.currentAgreement.agreement_end_date,
        deliveryDate: this.currentAgreement.delivery_date,
        firstPickup: this.currentAgreement.first_pickup
      }).then(d=> {
        // update schedule_string with new agreement_end_date
        this.updateScheduler();
      })
    },
    async updateScheduler(){
      // Update each service schedule string based on the new end date
      // console.log(this.currentAgreement.agreement_end_date)
      for(let i in this.currentAgreement.services){
        let serviceSchedule = {
          freq: null,
          interval: null,
          byweekday:[],
          bymonth: [],
          until: ''
        };

        // console.log(this.currentAgreement.services[i].id)
        if(this.currentAgreement.services[i].schedule_string !== 'ON CALL' && this.currentAgreement.services[i].schedule_string !== undefined){
          // console.log('input', this.currentAgreement.services[i].schedule_string)

          let rule = RRule.fromString((this.currentAgreement.services[i].schedule_string).toString());
          serviceSchedule.freq = rule.origOptions.freq
          serviceSchedule.byweekday = rule.origOptions.count
          serviceSchedule.bymonth = rule.origOptions.bymonth
          serviceSchedule.until = this.currentAgreement.agreement_end_date
          let schedule = new RRule(serviceSchedule)

          let serviceId = this.currentAgreement.services[i].id
          await this.updateServiceSchedule({
            id: parseInt(serviceId),
            schedule_string: schedule.toString()
          })
        }
      }
      location.reload()
    },
    async addSite(){
      await this.$validator.validateAll().then((response) => {
        // console.log(response)
        if(response){
          this.addLocation = !this.addLocation
          this.newSite.clientId = parseInt(this.$router.history.current.params.id)
          this.newSite.postcode = parseInt(this.newSite.postcode)
          this.createSite(this.newSite).then(s => {
            location.reload()
          })
        }
      })
    },
    activeServices(potentialServices){
      let activeServices = []
      for(var active in potentialServices){
        if( potentialServices[active].active ){
          activeServices.push(potentialServices[active])
        }
      }
      return activeServices
    },
    changeRoute(route) {
      if(route && route.params){
        let siteID = route.params.id;
        let isServiceAgreementExists = this.isServiceAgreementExists(siteID);
        // If a site does not have any service agreements then it is safe to delete else not
        let isSafeToDelete = false;
        if( !isServiceAgreementExists ) {
          isSafeToDelete = true;
        }
        route.params.isSafeToDelete = isSafeToDelete;
      }

      this.$router.push(route)
    },
    Daily() {
      // console.log(RRule.DAILY)
      return RRule.DAILY
    },
    Weekly() {
      // console.log(RRule.WEEKLY)
      return RRule.WEEKLY
    },
    Monthly() {
      // console.log(RRule.MONTHLY)
      return RRule.MONTHLY
    },
    Yearly() {
      // console.log(RRule.YEARLY)
      return RRule.YEARLY
    },
    editCurrentAgreement(agreement){
      this.currentAgreement = agreement;
      this.editAgreement = !this.editAgreement;

      // GAM get's automatically parsed as a date, so we need to convert it back to time
      let date = this.currentAgreement.gate_access_method
      let momentDay = moment(date).tz('Australia/Sydney').format('HH:mm');
      this.currentAgreement.gate_access_method = momentDay;
    },
    deleteCurrentAgreement(agreement){
      this.currentAgreement = agreement;
      let isNotSafeToDelete = true
      if(agreement && agreement.services){

        // check if there is any service active
        for(let i in agreement.services){
          if(agreement.services[i].active){
            isNotSafeToDelete = false
          }
        }

        // define message based on the services status
        if(!isNotSafeToDelete){
          this.currentMessage = 'Please delete all services before delete the agreement'
          this.isSafeToDelete = false
        } else {
          this.isSafeToDelete = true
          this.currentMessage = 'Are you sure you want to delete agreement: ' + agreement.id + '?'
        }
      }
      this.removeAgreement = !this.removeAgreement;
    },
    getServiceAgreements(siteID){
      let selectedServiceAgreements = this.serviceAgreements.filter( agreement => {
        return agreement.site_id === siteID;
      });
      return selectedServiceAgreements;
    },
    isServiceAgreementExists(siteID) {
      let serviceAgreements = this.getServiceAgreements(siteID);
      if ( serviceAgreements.length > 0 ) {
        return true;
      }
      return false;
    },
    manageAgreementDocuments(agreement){
      this.currentAgreement = agreement;
      this.manageDocuments = !this.manageDocuments;
      this.dropOptions.headers.id = this.currentAgreement.id;

      // GAM get's automatically parsed as a date, so we need to convert it back to time
      let date = this.currentAgreement.gate_access_method
      let momentDay = moment(date).tz('Australia/Sydney').format('HH:mm');
      this.currentAgreement.gate_access_method = momentDay;

      let files = this.currentAgreement.files;
      let fileCount = 0;
      this.documents = [];
      this.documentsObj = [];
      for(const file of files){
        file.name = ++fileCount;
        this.documents.push(file)
        this.documentsObj.push(file)
      }

    },
    getFileCount() {
      this.shouldReload = true;
      if (typeof this.$refs.myVueDropzone.dropzone !== 'undefined') {
        this.fileCount = this.$refs.myVueDropzone.dropzone.files.length
      } else {
        this.fileCount = 0;
      }
      // console.log('getfilecount ', this.fileCount)
    },
    deleteDocument(document){
      this.selectedDocumentId = this.documents.indexOf(document)
      this.removeDocument = true
    },
    actuallyDeleteDocument(){
      let obj = this.documentsObj[this.selectedDocumentId];
      let documentId = parseInt(obj.id)
      this.deleteAgreementDocument({Id:documentId}).then(()=>{
        this.shouldReload = true
        location.reload();
      })
    },
  },
}
</script>

<template>
  <Layout>
    <Loading :display="loadingData" />
    <VContainer>
      <!-- CLIENT CARD -->
      <h2>Client</h2>
      <!-- v-card-padding (15px) -->
      <VCard class="v-card-padding top-blue client-card">
        <VLayout
          row
          wrap
        >
          <VFlex
            xs12
            sm8
            md8
            lg8
            class="client-details"
          >
            <h3 class="fixedSpaceVertical">
              {{ client.client_name }}
            </h3>
            <p v-if="client">
              <i class="fas fa-user fixedSpaceHorizontal" /> {{ client.contact_name }}
            </p>
            <p><i class="fas fa-map-marker fixedSpaceHorizontal" /> {{ client.address }}, {{ client.suburb }} {{ client.postcode }}</p>
            <h5><strong>ABN</strong></h5>
            <p>{{ client.abn }}</p>
            <!--<h5><strong>Drivers License</strong></h5>-->
            <!--<p>{{ client.drivers_licence }}</p>-->
          </VFlex>

          <VFlex
            xs12
            sm4
            md4
            lg4
          >
            <h3 class="fixedSpaceVertical">
              Customer Contact
            </h3>
            <p><i class="fas fa-envelope fixedSpaceHorizontal" /> {{ client.email }}</p>
            <p><i class="fas fa-phone fixedSpaceHorizontal" /> {{ client.phone }}</p>
            <p><i class="fas fa-mobile-alt fixedSpaceHorizontal" /> {{ client.mobile }}</p>
            <p><i class="fas fa-fax fixedSpaceHorizontal" /> {{ client.fax }}</p>
          </VFlex>
        </VLayout>

        <VLayout
          row
          wrap
        >
          <VFlex
            xs12
            sm4
            md4
            lg3
            style="padding-bottom: 0;"
          >
            <VBtn
              color="blue"
              block
              outline
              @click.native="editClient = !editClient"
            >
              EDIT CLIENT
            </VBtn>
          </VFlex>

          <VFlex
            xs12
            sm4
            md4
            lg3
            class="view-Client-buttonMargin"
          >
            <VBtn
              v-if="this.$store.getters['auth/getUserRole'] == 'Admin'"
              color="orange"
              block
              @click.native="removeClient = !removeClient"
            >
              Delete Client
            </VBtn>
          </VFlex>

          <VFlex
            xs12
            sm4
            md4
            lg3
          >
            <VBtn
              color="green"
              block
              @click.native="changePwd = !changePwd"
            >
              CHANGE PASSWORD
            </VBtn>
          </VFlex>
        </VLayout>

        <VLayout>
          <VFlex
            xs12
          >
            <h4>Locations:</h4>
            <VDataTable
              v-if="clientSites"
              :headers="locationHeaders"
              :items="clientSites"
              hide-actions
            >
              <template
                v-if="props.item"
                slot="items"
                slot-scope="props"
              >
                <td>{{ props.item.trading_name }}</td>
                <td>{{ props.item.address }}</td>
                <td>{{ props.item.phone }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.contact_name }}</td>
                <td class="justify-center px-0">
                  <VBtn
                    slot="activator"
                    style="display: block; position:relative; margin: 0 auto"
                    color="blue"
                    @click.native="changeRoute({name: 'view-site', params: {id: props.item.id}})"
                  >
                    View
                  </VBtn>
                </td>
              </template>
            </VDataTable>
          </VFlex>
        </VLayout>
        <VLayout>
          <VFlex
            xs12
            sm3
          >
            <VBtn
              color="blue"
              block
              @click.native="addLocation = !addLocation"
            >
              Add Location
            </VBtn>
          </VFlex>
        </VLayout>
      </VCard>

      <br>
      <br>

      <!-- SERVICES CARDS -->
      <h2>Service Agreements</h2>

      <VCard
        v-for="agreement in serviceAgreements"
        :key="agreement.id"
        class="v-card-padding agreement-card client-card"
      >
        <h3
          v-if="agreement.site"
          class="fixedSpaceVertical"
        >
          {{ agreement.site.trading_name }}
        </h3>
        <p
          v-if="agreement.site"
        >
          <i class="fas fa-user fixedSpaceHorizontal" /> {{ agreement.site.contact_name }}
        </p>
        <p
          v-if="agreement.site"
        >
          <i class="fas fa-map-marker fixedSpaceHorizontal" /> {{ agreement.site.address }}, {{ agreement.site.suburb }} {{ agreement.site.postcode }}
        </p>

        <VLayout
          row
          wrap
        >
          <VFlex
            xs6
            md4
            style="padding: 0 !important;"
          >
            <p
              v-if="agreement.site"
            >
              <i

                class="fas fa-envelope fixedSpaceHorizontal"
              />
              {{ agreement.site.email }}
            </p>
          </VFlex>
          <VFlex
            xs6
            md4
            style="padding: 0 !important;"
          >
            <p
              v-if="agreement.site"
            ><i class="fas fa-phone fixedSpaceHorizontal" /> {{ agreement.site.phone }}</P>
          </VFlex>
          <VFlex
            xs6
            md4
            style="padding: 0 !important;"
          >
            <p
              v-if="agreement.site"
            ><i class="fas fa-mobile-alt fixedSpaceHorizontal" /> {{ agreement.site.mobile }}</P>
          </VFlex>
        </VLayout>

        <VLayout
          row
          wrap
        >
          <VFlex
            xs12
            md6
            style="padding: 0 !important;"
          >
            <p>Agreement Commencement Date: <strong>{{ agreement.agreement_commencement_date }}</strong> </p>
          </VFlex>
          <VFlex
            xs12
            md6
            style="padding: 0 !important;"
          >
            <p>Agreement End Date:  <strong>{{ agreement.agreement_end_date }}</strong> </p>
          </VFlex>
          <VFlex
            xs12
            md6
            style="padding: 0 !important;"
          >
            <p>Delivery Date:  <strong>{{ agreement.delivery_date }}</strong> </p>
          </VFlex>
          <VFlex
            xs12
            md6
            style="padding: 0 !important;"
          >
            <p>First Pickup:  <strong>{{ agreement.first_pickup }}</strong></p>
          </VFlex>
        </VLayout>

        <VLayout
          row
          wrap
        >
          <VFlex
            xs12
            sm3
            style="padding-bottom: 0 !important; padding-left: 0 !important;"
          >
            <VBtn
              color="blue"
              block
              outline
              @click.native="editCurrentAgreement(agreement)"
            >
              EDIT AGREEMENT
            </VBtn>
          </VFlex>
          <VFlex
            xs12
            sm4
            md4
            lg3
            class="view-Client-buttonMargin"
          >
            <VBtn
              v-if="$store.getters['auth/getUserRole'] === 'Admin'"
              color="orange"
              block
              @click.native="deleteCurrentAgreement(agreement)"
            >
              Delete Agreement
            </VBtn>
          </VFlex>
          <VFlex
            xs12
            sm3
            style="padding-bottom: 0 !important; padding-left: 15px !important;"
          >
            <VBtn
              color="green"
              block
              @click.native="manageAgreementDocuments(agreement)"
            >
              DOCUMENTS
            </VBtn>
          </VFlex>
        </VLayout>

        <VLayout
          row
          justify-center
        >
          <VDialog
            v-model="manageDocuments"
            persistent
            max-width="1024px"
            scrollable
          >
            <VCard>
              <VCardText>
                <VContainer grid-list-md>
                  <h2>Manage Document: {{ client.client_name }}</h2>
                  <h3>Upload Documents</h3>
                  <br>
                  <div id="appaa">
                    <VueDropzone
                      id="drop1"
                      ref="myVueDropzone"
                      :options="dropOptions"
                      @vdropzone-file-added="getFileCount"
                    />
                  </div>
                  <br>
                  <p v-if="fileCount != null">
                    File uploaded successfully, please refresh the page or close the modal to load the file on the list below.
                  </p>
                  <div>
                    <h3>Current Documents</h3>
                    <VDataTable
                      :headers="manageDocumentsHeaders"
                      :items="documents"
                      rows-per-page-text=""
                      :rows-per-page-items="[5]"
                    >
                      <template
                        slot="items"
                        slot-scope="props"
                      >
                        <td class="text-xs-left">
                          <a
                            target="_blank"
                            :href="props.item.url"
                          >
                            File {{ props.item.name }}
                          </a>

                        </td>
                        <td class="text-xs-left">
                          <VIcon
                            small
                            @click="deleteDocument(props.item)"
                          >
                            delete
                          </VIcon>
                        </td>
                      </template>
                    </VDataTable>
                  </div>
                  <VSpacer />
                  <br>
                  <VLayout
                    row
                    wrap
                  >
                    <VFlex
                      xs12
                      sm12
                      md4
                      lg4
                      offset-md4
                      offset-lg4
                    >
                      <VBtn
                        color="blue"
                        block
                        outline
                        @click.native="closeManageDocumentModal()"
                      >
                        Close
                      </VBtn>
                    </VFlex>
                  </VLayout>
                </VContainer>
              </VCardText>
            </VCard>
          </VDialog>
        </VLayout>

        <VLayout
          row
          justify-center
        >
          <VDialog
            v-model="removeDocument"
            persistent
            max-width="500px"
            scrollable
          >
            <VCard>
              <VCardText>
                <VContainer grid-list-md>
                  <h2>Are you sure you want to delete this document?</h2>
                  <VLayout wrap>
                    <VFlex
                      xs12
                      sm6
                      md6
                    >
                      <VBtn
                        color="blue"
                        block
                        outline
                        @click.native="removeDocument = !removeDocument"
                      >
                        Close
                      </VBtn>
                    </VFlex>
                    <VFlex
                      xs12
                      sm6
                      md6
                    >
                      <VBtn
                        color="orange"
                        block
                        @click.native="actuallyDeleteDocument()"
                      >
                        DELETE
                      </VBtn>
                    </VFlex>
                  </VLayout>
                </VContainer>
              </VCardText>
            </VCard>
          </VDialog>
        </VLayout>

        <VDataTable
          :headers="collectionHeaders"
          :items="activeServices(agreement.services)"
          hide-actions
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td>{{ props.item.service_title }}</td>
            <td class="text-xs-left">
              {{ props.item.service_type_id.name }} / <p v-if="props.item.waste_type">
                {{ props.item.waste_type.name }}
              </p>
            </td>
            <td class="text-xs-left">
              {{ props.item.capacitySum }}
            </td>
            <td class="text-xs-left">
              {{ props.item.schedule }}
            </td>
            <td class="text-xs-left">
              ${{ props.item.serviceSum / 100 }}
            </td>
            <td
              class="text-xs-left"
            >
              ${{ props.item.maintenanceSum / 100 }}
            </td>

            <td class="justify-center px-0">
              <VBtn
                slot="activator"
                style="display: block; position:relative; margin: 0 auto"
                color="blue"
                @click.native="changeRoute({name: 'view-service', params: {id: props.item.id, last_day_service: agreement.agreement_end_date}})"
              >
                View
              </VBtn>
            </td>
          </template>
        </VDataTable>

        <VLayout
          row
          wrap
          justify-center
        >
          <VFlex
            xs12
            md3
          >
            <VBtn
              :class="$style.addServiceButton"
              color="blue"
              block
              @click.native="newService.lastDayService = agreement.agreement_end_date, newService.service_agreement_id = agreement.id, newService.site_id = agreement.site_id, newService.client_id = agreement.client_id, showService = true"
            >
              ADD SERVICE
            </VBtn>
          </VFlex>
        </VLayout>

        <br>
        <div class="agreement-notes">
          <p>Notes:</p>
          <p>{{ agreement.notes }}</p>
        </div>
      </VCard>
      <br>
      <VBtn
        block
        color="white"
        @click.native="addAgreement = true"
      >
        ADD SERVICE AGREEMENT
      </VBtn>

      <VDialog
        v-model="changePwd"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Change Password</h2>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm12
                >
                  <VTextField
                    v-model="password"
                    label="New Password"
                    data-vv-name="new_password"
                    required
                    :append-icon="showNewPassword ? 'visibility_off' : 'visibility'"
                    :type="showNewPassword ? 'text' : 'password'"
                    @click:append="showNewPassword = !showNewPassword"
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm12
                >
                  <VTextField
                    v-model="passwordconfirm"
                    label="Confirm Password"
                    data-vv-name="confirm_password"
                    required
                    :append-icon="showConfirmPassword ? 'visibility_off' : 'visibility'"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    @click:append="showConfirmPassword = !showConfirmPassword"
                  />
                </VFlex>

                <VSpacer />

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="closePwdModal"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="green"
                    block
                    @click.native="resetPassword()"
                  >
                    Change Password
                  </VBtn>
                </VFlex>
                <p
                  v-if="authError"
                  :class="$style.error"
                >
                  Passwords do not match
                </p>
                <p
                  v-if="matchError"
                  :class="$style.error"
                >
                  Password cannot be empty
                </p>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>

      <!-- Update Client MODAL -->
      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="editClient"
          persistent
          max-width="500px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Update Client: {{ client.client_name }}</h2>
                <VLayout
                  wrap
                  data-vv-scrop="form-client-update"
                >
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="client.client_name"
                      v-validate="'required'"
                      :error-messages="errors.collect('name')"
                      label="Client Name"
                      data-vv-scope="form-client-update"
                      data-vv-name="name"
                      required
                    />
                    <p
                      v-if="errors.has('form-client-update.name')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-client-update.name') }}
                    </p>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="client.address"
                      v-validate="'required'"
                      :error-messages="errors.collect('address')"
                      label="Address"
                      data-vv-scope="form-client-update"
                      data-vv-name="address"
                      required
                    />
                    <p
                      v-if="errors.has('form-client-update.address')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-client-update.address') }}
                    </p>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="client.suburb"
                      v-validate="'required'"
                      :error-messages="errors.collect('suburb')"
                      label="Suburb"
                      data-vv-scope="form-client-update"
                      data-vv-name="suburb"
                      required
                    />
                    <p
                      v-if="errors.has('form-client-update.suburb')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-client-update.suburb') }}
                    </p>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="client.postcode"
                      v-validate="'required|integer|length:4'"
                      :error-messages="errors.collect('postcode')"
                      label="Postcode"
                      data-vv-scope="form-client-update"
                      data-vv-name="postcode"
                      required
                    />
                    <p
                      v-if="errors.has('form-client-update.postcode')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-client-update.postcode') }}
                    </p>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="client.phone"
                      v-validate="'required|integer'"
                      :error-messages="errors.collect('phone')"
                      label="Phone"
                      data-vv-scope="form-client-update"
                      data-vv-name="phone"
                      required
                    />
                    <p
                      v-if="errors.has('form-client-update.phone')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-client-update.phone') }}
                    </p>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="client.fax"
                      v-validate="'integer'"
                      :error-messages="errors.collect('fax')"
                      label="Fax"
                      data-vv-scope="form-client-update"
                      data-vv-name="fax"
                      required
                    />
                    <p
                      v-if="errors.has('form-client-update.fax')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-client-update.fax') }}
                    </p>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="client.mobile"
                      v-validate="'integer'"
                      :error-messages="errors.collect('mobile')"
                      label="Mobile"
                      data-vv-scope="form-client-update"
                      data-vv-name="mobile"
                      required
                    />
                    <p
                      v-if="errors.has('form-client-update.mobile')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-client-update.mobile') }}
                    </p>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="client.contact_name"
                      v-validate="'required'"
                      :error-message="errors.collect('contact name')"
                      label="Contact Name"
                      data-vv-scope="form-client-update"
                      data-vv-name="contact name"
                      required
                    />
                    <p
                      v-if="errors.has('form-client-update.contact name')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-client-update.contact name') }}
                    </p>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="client.title"
                      label="Title"
                      data-vv-name="title"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="client.email"
                      v-validate="'required|email'"
                      :error-messages="errors.collect('email')"
                      label="Email"
                      data-vv-scope="form-client-update"
                      data-vv-name="email"
                      required
                    />
                    <p
                      v-if="errors.has('form-client-update.email')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-client-update.email') }}
                    </p>
                  </VFlex>
                  <VFlex
                    xs12
                    sm12
                  >
                    <VTextField
                      v-model="client.abn"
                      v-validate="'required|integer|length:11'"
                      :error-messages="errors.collect('ABN')"
                      label="ABN"
                      data-vv-scope="form-client-update"
                      data-vv-name="ABN"
                      required
                    />
                    <p
                      v-if="errors.has('form-client-update.ABN')"
                      class="theme--light v-messages"
                    >
                      {{ errors.first('form-client-update.ABN') }}
                    </p>
                  </VFlex>
                  <!--<VFlex-->
                  <!--xs12-->
                  <!--sm6-->
                  <!--&gt;-->
                  <!--<VTextField-->
                  <!--v-model="client.drivers_licence"-->
                  <!--label="Drivers License"-->
                  <!--data-vv-name="license"-->
                  <!--required-->
                  <!--/>-->
                  <!--</VFlex>-->

                  <!--<VFlex-->
                  <!--xs12-->
                  <!--sm6-->
                  <!--&gt;-->
                  <!--<VTextField-->
                  <!--v-model="client.password"-->
                  <!--label="Password"-->
                  <!--data-vv-name="password"-->
                  <!--required-->
                  <!--/>-->
                  <!--</VFlex>-->

                  <VSpacer />

                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="editClient = !editClient"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      @click.native="update()"
                    >
                      Save
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>

      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="editAgreement"
          persistent
          max-width="500px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Update Service Agreement: {{ currentAgreement.id }}</h2>
                <VLayout wrap>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VSelect
                      v-model="currentAgreement.site_id"
                      :menu-props="{ absolute: false }"
                      attach
                      label="Site"
                      :items="siteNames()"
                      item-text="address"
                      item-value="site_id"
                      data-vv-name="Site"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="currentAgreement.gate_access_method"
                      label="Gate Access Time"
                      data-vv-name="gate_access_method"
                      type="time"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="currentAgreement.agreement_commencement_date"
                      label="Commencement Date"
                      data-vv-name="agreement_commencement_date"
                      type="date"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="currentAgreement.agreement_end_date"
                      label="End Date"
                      data-vv-name="agreement_end_date"
                      type="date"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="currentAgreement.delivery_date"
                      label="Delivery Date"
                      data-vv-name="ddate"
                      type="date"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="currentAgreement.first_pickup"
                      label="First Pickup"
                      data-vv-name="First Pickup"
                      type="date"
                      required
                    />
                  </VFlex>

                  <VFlex
                    xs12
                    sm12
                  >
                    <VTextField
                      v-model="currentAgreement.notes"
                      label="Notes"
                      data-vv-name="notes"
                      required
                    />
                  </VFlex>

                  <VSpacer />

                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="editAgreement = !currentAgreement"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      @click.native="updateAgreement()"
                    >
                      Save
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>

      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="removeClient"
          persistent
          max-width="500px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Are you sure you want to delete {{ client.client_name }}?</h2>
                <VLayout wrap>

                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="removeClient = !removeClient"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="orange"
                      block
                      @click.native="submit()"
                    >
                      DELETE
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>
    </VContainer>

    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="removeAgreement"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>{{ currentMessage }}</h2>
              <!--              <h2>Are you sure you want to delete agreement: {{ currentAgreement.id }}?</h2>-->
              <VLayout wrap>

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="removeAgreement = !removeAgreement"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="orange"
                    block
                    :disabled="!isSafeToDelete"
                    @click.native="performDeleteAgreement()"
                  >
                    DELETE
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

    <!-- Add service agreement card -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="addAgreement"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Service Agreement</h2>
              <VLayout
                wrap
                data-vv-scope="form-agreement"
              >
                <VFlex
                  xs12
                  sm6
                >
                  <VSelect
                    v-model="newServiceAgreement.siteId"
                    v-validate="'required'"
                    data-vv-scope="form-agreement"
                    :menu-props="{ absolute: false }"
                    attach
                    label="Site"
                    :items="siteNames()"
                    item-text="address"
                    item-value="site_id"
                    data-vv-name="site"
                    required
                  />
                  <p
                    v-if="errors.has('form-agreement.site')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-agreement.site') }}
                  </p>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newServiceAgreement.gateAccessMethod"
                    v-validate="'required'"
                    data-vv-scope="form-agreement"
                    label="Gate Access Time"
                    data-vv-name="gate_access_method"
                    type="time"
                    required
                  />
                  <p
                    v-if="errors.has('form-agreement.gate_access_method')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-agreement.gate_access_method') }}
                  </p>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newServiceAgreement.agreementCommencementDate"
                    v-validate="'required'"
                    data-vv-scope="form-agreement"
                    label="Commencement Date"
                    data-vv-name="commencement_date"
                    type="date"
                    required
                  />
                  <p
                    v-if="errors.has('form-agreement.commencement_date')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-agreement.commencement_date') }}
                  </p>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newServiceAgreement.agreementEndDate"
                    v-validate="'required'"
                    data-vv-scope="form-agreement"
                    label="End Date"
                    data-vv-name="end_date"
                    type="date"
                    required
                  />
                  <p
                    v-if="errors.has('form-agreement.end_date')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-agreement.end_date') }}
                  </p>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newServiceAgreement.deliveryDate"
                    v-validate="'required'"
                    data-vv-scope="form-agreement"
                    label="Delivery Date"
                    data-vv-name="delivery_date"
                    type="date"
                    required
                  />
                  <p
                    v-if="errors.has('form-agreement.delivery_date')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-agreement.delivery_date') }}
                  </p>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newServiceAgreement.firstPickup"
                    v-validate="'required'"
                    data-vv-scope="form-agreement"
                    label="First Pickup"
                    data-vv-name="first_pickup"
                    type="date"
                    required
                  />
                  <p
                    v-if="errors.has('form-agreement.first_pickup')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-agreement.first_pickup') }}
                  </p>
                </VFlex>

                <VFlex
                  xs12
                  sm12
                >
                  <VTextField
                    v-model="newServiceAgreement.notes"
                    label="Notes"
                    data-vv-name="notes"
                    required
                  />
                </VFlex>

                <VSpacer />

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="addAgreement = !addAgreement"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="saveAgreement()"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>
    <!-- Update Location MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="addLocation"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Add Location</h2>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newSite.address"
                    v-validate="'required'"
                    :error-messages="errors.collect('address')"
                    label="Address"
                    data-vv-name="address"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newSite.suburb"
                    v-validate="'required'"
                    :error-messages="errors.collect('suburb')"
                    label="Suburb"
                    data-vv-name="suburb"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newSite.state"
                    v-validate="'required'"
                    :error-messages="errors.collect('state')"
                    label="State"
                    data-vv-name="state"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newSite.country"
                    v-validate="'required'"
                    :error-messages="errors.collect('country')"
                    label="Country"
                    data-vv-name="country"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newSite.postcode"
                    v-validate="'required'"
                    :error-messages="errors.collect('postcode')"
                    label="Postcode"
                    data-vv-name="postcode"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newSite.phone"
                    v-validate="'required'"
                    :error-messages="errors.collect('phone')"
                    label="Phone"
                    data-vv-name="phone"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newSite.mobile"
                    v-validate="'required'"
                    :error-messages="errors.collect('mobile')"
                    label="Mobile"
                    data-vv-name="mobile"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newSite.contactName"
                    v-validate="'required'"
                    :error-messages="errors.collect('contact name')"
                    label="Contact Name"
                    data-vv-name="contact name"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newSite.email"
                    v-validate="'required|email'"
                    :error-messages="errors.collect('email')"
                    label="Email"
                    data-vv-name="email"
                    required
                  />
                </VFlex>
                <VFlex
                  xs12
                  sm6
                >
                  <VTextField
                    v-model="newSite.tradingName"
                    v-validate="'required'"
                    :error-messages="errors.collect('trading name')"
                    label="Trading Name"
                    data-vv-name="trading name"
                    required
                  />
                </VFlex>

                <VSpacer />

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="addLocation = !addLocation"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="addSite()"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

    <!-- ADD SERVICE MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="showService"
        persistent
        scrollable
        max-width="500px"
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>New Service</h2>
              <VLayout
                wrap
                data-vv-scope="form-service"
              >
                <VFlex xs12>
                  <VTextField
                    v-model="newService.service_title"
                    data-vv-scope="form-service"
                    data-vv-name="title"
                    label="Title"
                    hint="(Optional) Leave blank to use the Service Type title"
                    persistent-hint
                    required
                  />
                  <p
                    v-if="errors.has('form-service.title')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-service.title') }}
                  </p>
                </VFlex>
                <VFlex xs12>
                  <VAutocomplete
                    v-model="serviceTypeName"
                    v-validate="'required'"
                    data-vv-scope="form-service"
                    data-vv-name="service_type"
                    :items="serviceTypeNames"
                    label="Service Type"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                    :search-input.sync="serviceSearchInput"
                  />
                  <p
                    v-if="errors.has('form-service.service_type')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-service.service_type') }}
                  </p>
                </VFlex>
                <VFlex xs12>
                  <VAutocomplete
                    v-model="wasteTypeName"
                    v-validate="'required'"
                    data-vv-scope="form-service"
                    data-vv-name="waste_type"
                    :items="wasteTypeNames"
                    label="Waste Type"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                    :search-input.sync="wasteSearchInput"
                  />
                  <p
                    v-if="errors.has('form-service.waste_type')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-service.waste_type') }}
                  </p>
                </VFlex>
                <!--<VFlex xs12>-->
                <!--<VTextField-->
                <!--v-model="newService.order_number"-->
                <!--label="Order Number"-->
                <!--required-->
                <!--/>-->
                <!--</VFlex>-->
                <VFlex xs6>
                  <VTextField
                    v-model="newService.time_windows[0][0]"
                    type="number"
                    label="Time Window Start"
                    required
                    :menu-props="{ absolute: true }"
                  />
                </VFlex>
                <VFlex xs6>
                  <VTextField
                    v-model="newService.time_windows[0][1]"
                    type="number"
                    label="Time Window End"
                    required
                    :menu-props="{ absolute: true }"
                  />
                </VFlex>
                <VFlex xs12>
                  <h3>Service Bins</h3>
                </VFlex>
                <VFlex xs12>
                  <VAutocomplete
                    v-model="binType"
                    v-validate="'required'"
                    data-vv-scope="form-service"
                    data-vv-name="bin_type"
                    :items="binDescriptions"
                    label="Bin Type"
                    required
                    attach
                    :menu-props="{ absolute: true }"
                    :search-input.sync="binsSearchInput"
                  />
                  <p
                    v-if="errors.has('form-service.bin_type')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-service.bin_type') }}
                  </p>
                </VFlex>
                <VFlex xs6>
                  <VCheckbox
                    v-model="newServiceBin.padlocks"
                    label="Padlocks"
                  />
                </VFlex>
                <VFlex xs6>
                  <VCheckbox
                    v-model="newServiceBin.castors"
                    label="Castors"
                  />
                </VFlex>
                <VFlex xs6>
                  <VTextField
                    v-model="newServiceBin.price"
                    v-validate="'required'"
                    data-vv-scope="form-service"
                    data-vv-name="service_fee"
                    type="number"
                    label="Service fee"
                    required
                    :menu-props="{ absolute: false }"
                    prefix="$"
                  />
                  <p
                    v-if="errors.has('form-service.service_fee')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-service.service_fee') }}
                  </p>
                </VFlex>
                <VFlex xs6>
                  <VTextField
                    v-model="newServiceBin.weeklyMaintenanceFee"
                    v-validate="'required'"
                    data-vv-scope="form-service"
                    data-vv-name="maintenance_fee"
                    type="number"
                    label="Maintenance fee"
                    required
                    :menu-props="{ absolute: false }"
                    prefix="$"
                  />
                  <p
                    v-if="errors.has('form-service.maintenance_fee')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-service.maintenance_fee') }}
                  </p>
                </VFlex>
                <VFlex xs6>
                  <VTextField
                    v-model="newServiceBin.weightAllowed"
                    data-vv-scope="form-service"
                    data-vv-name="weight_allowed"
                    type="number"
                    label="Weight Allowed"
                    :menu-props="{ absolute: false }"
                  />
                  <p
                    v-if="errors.has('form-service.weight_allowed')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-service.weight_allowed') }}
                  </p>
                </VFlex>
                <VFlex xs6>
                  <VTextField
                    v-model="newServiceBin.extraPrice"
                    data-vv-scope="form-service"
                    data-vv-name="extra_price"
                    type="number"
                    label="Extra Price"
                    :menu-props="{ absolute: false }"
                    prefix="$"
                  />
                  <p
                    v-if="errors.has('form-service.extra_price')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-service.extra_price') }}
                  </p>
                </VFlex>
                <VFlex xs6>
                  <VCheckbox
                    v-model="newServiceBin.chargePerTonne"
                    label="Charge per Tonne"
                  />
                </VFlex>
                <VFlex xs6>
                  <VCheckbox
                    v-model="newServiceBin.chargePerLitre"
                    label="Charge per Litre"
                  />
                </VFlex>
                <VFlex xs12>
                  <h3>Service Schedule</h3>
                </VFlex>
                <VFlex xs12>
                  <VCheckbox
                    v-model="newService.serviceOnCall"
                    label="On Call service"
                  />
                </VFlex>
                <VFlex xs12>
                  <VSelect
                    v-model="serviceSchedule.freq"
                    v-validate="!newService.serviceOnCall ? 'required' : ''"
                    data-vv-scope="form-service"
                    data-vv-name="frequency"
                    :items="[
                      {freq: 'Daily', rule: Daily() },
                      {freq: 'Weekly', rule: Weekly() },
                      {freq: 'Monthly', rule: Monthly() },
                      {freq: 'Annually', rule: Yearly() },
                    ]"
                    item-text="freq"
                    item-value="rule"
                    label="Frequency"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                  />
                  <p
                    v-if="errors.has('form-service.frequency')"
                    class="theme--light v-messages"
                  >
                    {{ errors.first('form-service.frequency') }}
                  </p>
                </VFlex>
                <VFlex xs12>
                  <VExpansionPanel
                    expand
                    inset
                  >
                    <VExpansionPanelContent inset>
                      <div slot="header">
                        Set Days of Week
                      </div>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.byweekday"
                          label="Monday"
                          color="secondary"
                          value="0"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.byweekday"
                          label="Tuesday"
                          color="primary"
                          value="1"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.byweekday"
                          label="Wednesday"
                          color="secondary"
                          value="2"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.byweekday"
                          label="Thursday"
                          color="primary"
                          value="3"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.byweekday"
                          label="Friday"
                          color="secondary"
                          value="4"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.byweekday"
                          label="Saturday"
                          color="primary"
                          value="5"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.byweekday"
                          label="Sunday"
                          color="secondary"
                          value="6"
                          hide-details
                        />
                      </VFlex>
                </vexpansionpanelcontent></vexpansionpanel></VFlex>
                <VFlex xs12>
                  <VExpansionPanel
                    expand
                    inset
                  >
                    <VExpansionPanelContent inset>
                      <div slot="header">
                        Set Months of Year
                      </div>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Jan"
                          color="secondary"
                          value="1"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Feb"
                          color="primary"
                          value="2"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Mar"
                          color="secondary"
                          value="3"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Apr"
                          color="primary"
                          value="4"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="May"
                          color="secondary"
                          value="5"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Jun"
                          color="secondary"
                          value="6"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Jul"
                          color="primary"
                          value="7"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Aug"
                          color="secondary"
                          value="8"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Sep"
                          color="primary"
                          value="9"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Oct"
                          color="secondary"
                          value="10"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Nov"
                          color="primary"
                          value="11"
                          hide-details
                        />
                      </VFlex>
                      <VFlex xs4>
                        <VCheckbox
                          v-model="serviceSchedule.bymonth"
                          label="Dec"
                          color="secondary"
                          value="12"
                          hide-details
                        />
                      </VFlex>
                </vexpansionpanelcontent></vexpansionpanel></VFlex>
                <VFlex xs12>
                  <VTextField
                    v-model="serviceSchedule.interval"
                    type="number"
                    label="Interval between collections"
                    default="1"
                    required
                    absolute
                  />
                </VFlex>
                <VFlex xs12>
                  <VAutocomplete
                    v-model="newService.vehicle_id"
                    data-vv-name="vehicle"
                    :items="vehiclePlates"
                    item-text="id"
                    label="Vehicle"
                    :menu-props="{ absolute: true }"
                    attach
                  />
                </VFlex>
                <VSpacer />

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="showService = false"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="addService()"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

  .error{
    width: 100%;
    padding:25px 25px 0 25px;
    color: red;
    text-align: center;
  }

  .client-card{
    border: 0 solid $blue;
    border-top-width: 10px;
  }

  .addServiceButton {
    position: relative;
    bottom: 10px;
    display: block;
    margin: 0 auto;
    margin-top: 30px;
  }

  VExpansionPanelContent{
    .flex{
      display: inline-block;
    }
  }

  @media screen and (max-width: 980px) {
    .view-Client-buttonMargin {
      margin-top: 15px !important;
    }
  }
</style>
